<i18n src="./../../i18n/delivery_form.json"></i18n>

<template>
    <div id="form-delivery" class="row p-0 m-0 mt-delivery no-gutters mt-3 pb-4">
        <div class="col-lg-12 mt-product-main-details p-4">
            <p class="font-weight-bold mt-fs-x-large pt-2" v-text="$t('title')"/>
        </div>
        <div class="col-lg-12 pl-4 pr-4">
            <google-map-loader :clickable="false" :draggable="true" :autocomplete="autocompleteObj" :key="renderKey" :position-x="deliveryForm.address.latitude" :position-y="deliveryForm.address.longitude"/>
        </div>

        <div class="fieldset-wrapper w-100 pl-4 pr-4 pt-4">
            <p class="mb-2" v-text="$t('delivery.address')" />
            <div class="no-gutters">
                <input class="form-control" id="fake-input">
                <component :is="autocompleteComp" ref="address" id="autocompleteInput" classname="form-control" :placeholder="$t('delivery.addressPlaceholder')" v-on:placechanged="getAddressData" v-on:keyup="onAddressKeyUp" :country="locale"></component>
            </div>

            <p class="mb-2" v-text="$t('delivery.from')" />
            <div class="no-gutters">
                <date-picker id="start-date" ref="startDatePicker" v-model="deliveryForm.startDate" :config="startDateOptions"></date-picker>
            </div>

            <p class="mb-2" v-text="$t('delivery.to')" />
            <div class="no-gutters">
                <date-picker id="end-date" ref="endDatePicker" v-model="deliveryForm.endDate" :config="endDateOptions"></date-picker>
            </div>

            <p class="mb-2" v-text="$t('delivery.phone')" />
            <div class="no-gutters">
                <input class="required form-control" id="contact-phone" v-model="deliveryForm.contactPhone" :placeholder="$t('delivery.phonePlaceholder')">
            </div>

            <p class="mb-2" v-text="$t('delivery.note')" />
            <div class="no-gutters">
                <textarea class="required form-control" id="delivery-info" v-model="deliveryForm.deliveryInfo" :placeholder="$t('delivery.notePlaceholder')"/>
            </div>
        </div>

        <p class="text-justify mt-3 pb-2 pl-4 pr-4"><span v-html="$t('info1.left', { phone: contactPhone })"/> <router-link :to="{name: 'contact'}" v-text="$t('info1.linkTitle')" /><span v-html="$t('info1.right')"/></p>
        <p class="text-justify pl-4 pr-4" v-html="$t('info2')" />
    </div>
</template>

<script>
    import $ from "jquery";
    import GoogleMapLoader from "@/components/commons/GoogleMapLoader";
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import DatePicker from 'vue-bootstrap-datetimepicker';
    import {Const} from "@/main";

    export default {
        name: "DeliveryForm",
        components: {GoogleMapLoader, 'vue-google-autocomplete': VueGoogleAutocomplete, DatePicker},
        props: {
            deliveryForm: {}
        },
        data () {
            return {
                locale: this.$i18n.locale,
                contactPhone: Const.CONTACT_PHONE,
                startDateOptions: {
                    locale: this.$i18n.locale,
                    minDate: this.getFirstAvailableDeliveryDate(),
                    format: 'DD-MM-YYYY',
                    daysOfWeekDisabled: [0,6],
                },
                endDateOptions: {
                    locale: this.$i18n.locale,
                    minDate: this.getFirstAvailableEndDate(),
                    defaultDate: this.getDefaultEndDate(),
                    format: 'DD-MM-YYYY',
                    daysOfWeekDisabled: [0,6]
                },
                renderKey: 0,
                autocompleteComp: '',
                autocompleteObj: {}
            }
        },
        mounted() {
            var app = this
            setTimeout(function(){
                app.autocompleteComp = 'vue-google-autocomplete'
                $('#fake-input-label').hide()
                $('#fake-input').hide()
            }, 1000);

            setTimeout(function () {
                app.autocompleteObj = app.$refs.address
            }, 2000);
            this.deliveryForm.startDate = this.getFirstAvailableDeliveryDate()
            this.deliveryForm.endDate = this.getDefaultEndDate()
        },
        beforeDestroy() {
        },
        methods: {
            validate() {
                let valid = true

                // miejsce dostawy

                // uzupełnij z pola jeżeli google-autocomplete nie zadziałało
                if (this.deliveryForm.address.name.trim() === '' && this.$refs.address.autocompleteText)
                    this.deliveryForm.address.name = this.$refs.address.autocompleteText

                if (this.deliveryForm.address.name.trim() === '') {
                    valid = false
                    $('#autocompleteInput').addClass('invalid-form')
                    $('#delivery-address-error').removeClass('d-none')
                    $('#delivery-address-error span').text(this.$t('form.required'))
                } else {
                    $('#autocompleteInput').removeClass('invalid-form')
                    $('#delivery-address-error').addClass('d-none')
                }

                // data dostawy - startDate
                if (!this.deliveryForm.startDate) {
                    valid = false
                    $('#start-date').addClass('invalid-form')
                    $('#delivery-start-date-error').removeClass('d-none')
                    $('#delivery-start-date-error span').text(this.$t('form.required'))
                } else {
                    $('#start-date').removeClass('invalid-form')
                    $('#delivery-start-date-error').addClass('d-none')
                }

                // data dostawy - endDate
                if (!this.deliveryForm.endDate) {
                    valid = false
                    $('#end-date').addClass('invalid-form')
                    $('#delivery-end-date-error').removeClass('d-none')
                    $('#delivery-end-date-error span').text(this.$t('form.required'))
                } else {
                    $('#end-date').removeClass('invalid-form')
                    $('#delivery-end-date-error').addClass('d-none')
                }

                // nr telefonu
                if (this.deliveryForm.contactPhone.trim() === '') {
                    valid = false
                    $('#contact-phone').addClass('invalid-form')
                    $('#contact-phone-error').removeClass('d-none')
                    $('#contact-phone-error span').text(this.$t('form.required'))
                } else {
                    var phone = this.deliveryForm.contactPhone.replace(/[^0-9a-zA-Z]/g, "")
                    var phoneReg;
                    if (Const.PRIMARY_LOCALE === 'pl') {
                        phoneReg = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
                    } else if (Const.PRIMARY_LOCALE === 'lt') {
                        phoneReg = /^0[-. ]?\(?([0-9]{3})\)?[-. ]?([0-9]{5})$/;
                    } else {
                        // like PL
                        phoneReg = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
                    }
                    if(!phone.match(phoneReg)) {
                        valid = false
                        $('#contact-phone').addClass('invalid-form')
                        $('#contact-phone-error').removeClass('d-none')
                        $('#contact-phone-error span').text(this.$t('form.invalidPhone'))
                    } else {
                        $('#contact-phone').removeClass('invalid-form')
                        $('#contact-phone-error').addClass('d-none')
                    }
                }

                return valid;
            },
            getAddressData: function (addressData) {
                this.deliveryForm.address.name = this.autocompleteObj.$refs.autocomplete.value
                if (addressData) {
                    this.deliveryForm.address.latitude = addressData.latitude;
                    this.deliveryForm.address.longitude = addressData.longitude;
                    this.forceRerender()
                }

            },
            onAddressKeyUp: function () {
                if (this.$refs.address && this.$refs.address.$refs.autocomplete) {
                    this.deliveryForm.address.name = this.$refs.address.$refs.autocomplete.value
                }
            },
            forceRerender() {
                this.renderKey += 1;
            },
            getFirstAvailableDeliveryDate() {
                var date = new Date(Date.now() + 2 * 86400000)
                if (date.getDay() === 0)
                    date = new Date(Date.now() + 3 * 86400000)
                else if (date.getDay() === 6)
                    date = date = new Date(Date.now() + 4 * 86400000)

                return date
            },
            getFirstAvailableEndDate() {
                var date = new Date(Date.now() + 3 * 86400000)
                if (date.getDay() === 0)
                    date = new Date(Date.now() + 4 * 86400000)
                else if (date.getDay() === 6)
                    date = date = new Date(Date.now() + 5 * 86400000)

                return date
            },
            getDefaultEndDate() {
                var date = new Date(Date.now() + 30 * 86400000)
                if (date.getDay() === 0)
                    date = new Date(Date.now() + 31 * 86400000)
                else if (date.getDay() === 6)
                    date = date = new Date(Date.now() + 32 * 86400000)

                return date
            },
        }
    }
</script>

<style scoped>
    .form-error {
        font-size: 0.8rem;
        color: red;
        opacity: 0.7;
    }

    .driver-info {
        height: 117px !important;
    }

    .input-field-with-on input {
        padding-left: 125px;
    }

    /deep/ #map-responsive {
        padding-bottom: 35% !important;
    }

    .mt-delivery {
        background-color: #fff;
        padding-top: 1rem;
        border: 1px solid #e7e7e7;
    }

    .fieldset-wrapper input, .fieldset-wrapper textarea {
        width: 100%;
        height: 50px;
        outline: 0;
        background: #fafafa;
        border: 0;
        border-radius: 0;
        margin: 0 0 15px;
        padding: 25px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        font-size: 14px;
    }

    .fieldset-wrapper textarea {
        height: 100px;
    }
</style>